//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

import angular from 'angular';

import template from './nav3-menu-item.html';

import { IStateWithData } from 'app/initialization/routing/stateHelpers';
import { dashboardStatesByName as states } from '../../top-level-states';

angular.module('curalate').component('nav3MenuItem', {
  bindings: {
    id: '@',
    state: '@',
    text: '@',
    isNew: '<?',
    newTagExpiration: '<?',
    isBeta: '<?',
  },
  template,
  transclude: true,
  require: {
    topNavCtrl: '^^?topNavigation',
  },
  controller: [
    'TrackingService',
    function (TrackingService) {
      this.$onInit = () => {
        this.isPathAllowed = (() => {
          return this.getState().data.hasAccess();
        })();

        const today = new Date();
        if (this.newTagExpiration) {
          const newDateExpiration = new Date(this.newTagExpiration);
          this.isNew = today < newDateExpiration;
        }
      };

      this.onClick = function (event: MouseEvent) {
        const targetPath = (event.currentTarget as HTMLAnchorElement).pathname;

        TrackingService.recordEvent(
          TrackingService.CATEGORY_NAVIGATION3,
          this.topNavCtrl
            ? TrackingService.ACTION_NAVIGATION3_TOP_NAV_PAGE_CLICK
            : TrackingService.ACTION_NAVIGATION3_WELCOME_SCREEN_PAGE_CLICK,
          targetPath,
        );
      };

      this.getState = function (): IStateWithData | null {
        return states[this.state];
      };
    },
  ],
});
